/* ===============================================
   SYSTÈME DE DEBUG ET RETRY POUR LES BUNDLES
   =============================================== */

// Mode debug : mettre à true pour voir les logs en console
// Utiliser window.museauBundleDebug = true; en console pour activer
window.museauBundleDebug = window.museauBundleDebug || false;

function debugLog(...args) {
  if (window.museauBundleDebug) {
    console.log('[🔍 Bundle Debug]', ...args);
  }
}

// Système de retry pour updateMainButtonPrice
let priceUpdateAttempts = 0;
const MAX_RETRY_ATTEMPTS = 5;
const RETRY_DELAYS = [300, 600, 1000, 1500, 2000]; // Délais progressifs en ms

function numberToEuro(number){
  const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
  return euroValue;
}

function formatDurationMonths(months) {
  if (!Number.isFinite(months) || months < 0) {
    return '';
  }

  if (months < 1) {
    const weeks = Math.max(1, Math.round((months * 30) / 7));
    return `${weeks} semaine${weeks > 1 ? 's' : ''}`;
  }

  const roundedMonths = Math.round(months);
  if (Math.abs(months - roundedMonths) <= 0.05) {
    return `${roundedMonths} mois`;
  }

  const fractional = months - Math.floor(months);
  const halfThresholds = [1 / 3, 0.5, 2 / 3];
  const isHalf = halfThresholds.some((target) => Math.abs(fractional - target) <= 0.1);

  if (isHalf) {
    const baseMonths = Math.floor(months);
    if (baseMonths <= 0) {
      return 'un demi-mois';
    }

    return `${baseMonths} mois et demi`;
  }

  return `${roundedMonths} mois`;
}

// VARIANTS GESTION

const productRoot = document.querySelector('.product');
const defaultUnitSuffix = '/pdt';
const productUnitSuffix = (() => {
  if (!productRoot) {
    return defaultUnitSuffix;
  }

  const unitLabel = productRoot.dataset.unitLabel ? productRoot.dataset.unitLabel.trim() : '';

  if (!unitLabel) {
    return defaultUnitSuffix;
  }

  return `/${unitLabel}`;
})();

const productVariantsDatabase = document.querySelector('.product .product-variants-database');

function escapeSelectorValue(value) {
  if (typeof value !== 'string') {
    return '';
  }

  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(value);
  }

  return value.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
}

function findDatabaseInputByOptionValues(values, databaseItems) {
  if (!databaseItems || !values || values.length === 0) {
    return null;
  }

  const filteredValues = values.filter((value) => Boolean(value && value.trim()));

  if (!filteredValues.length) {
    return null;
  }

  return Array.from(databaseItems).find((input) => {
    const inputTitle = input.getAttribute('data-title') || '';
    return filteredValues.every((optionValue) => inputTitle.includes(optionValue));
  }) || null;
}

function findInputForLabel(label) {
  if (!label) {
    return null;
  }

  const htmlFor = label.getAttribute('for');

  if (htmlFor) {
    return document.querySelector(`#${escapeSelectorValue(htmlFor)}`);
  }

  return label.querySelector('input');
}

function syncOptionDataset(targetElements, databaseInput) {
  if (!databaseInput || !targetElements || targetElements.length === 0) {
    return;
  }

  const sourceDataset = databaseInput.dataset || {};
  const datasetMapping = {
    optionPrice: sourceDataset.price || '',
    optionCompareAtPrice: sourceDataset.compareAtPrice || '',
    optionQuantity: sourceDataset.quantity || '',
    optionDurationDays: sourceDataset.durationDays || '',
    optionDurationMonth: sourceDataset.durationMonth || '',
    optionMeasureUnit: sourceDataset.measureUnit || '',
    optionWeight: sourceDataset.weight || ''
  };

  targetElements.forEach((target) => {
    if (!target || !target.dataset) {
      return;
    }

    Object.entries(datasetMapping).forEach(([key, value]) => {
      if (value) {
        target.dataset[key] = value;
      } else {
        delete target.dataset[key];
      }
    });
  });
}

function applyVariantPricing(targetElement, databaseInput) {
  if (!targetElement) {
    return;
  }

  const dataset = databaseInput ? databaseInput.dataset || {} : {};
  const priceData = dataset.price;
  const compareAtData = dataset.compareAtPrice;
  const totalPriceCents = priceData ? parseInt(priceData, 10) : NaN;
  const compareAtPriceCents = compareAtData ? parseInt(compareAtData, 10) : NaN;

  const regularPriceContainer = targetElement.querySelector('.option-price .regular-price');
  if (regularPriceContainer) {
    if (!Number.isNaN(totalPriceCents)) {
      regularPriceContainer.textContent = `${numberToEuro(totalPriceCents)}`;
    } else {
      regularPriceContainer.textContent = '';
    }
  }

  const unitPriceContainer = targetElement.querySelector('.option-price .unit-price');
  if (unitPriceContainer) {
    const quantityValue = dataset.quantity ? parseFloat(dataset.quantity) : NaN;
    if (!Number.isNaN(totalPriceCents) && !Number.isNaN(quantityValue) && quantityValue > 0) {
      const unitPriceCents = Math.round(totalPriceCents / quantityValue);
      const formattedUnitPrice = numberToEuro(unitPriceCents).replace('€', ' €');
      unitPriceContainer.textContent = `${formattedUnitPrice}${productUnitSuffix}`;
    } else {
      unitPriceContainer.textContent = '';
    }
  }

  const dailyPriceContainer = targetElement.querySelector('.option-price .daily-price');
  if (dailyPriceContainer) {
    const durationDaysValue = dataset.durationDays ? parseFloat(dataset.durationDays) : NaN;
    if (!Number.isNaN(totalPriceCents) && !Number.isNaN(durationDaysValue) && durationDaysValue > 0) {
      const dailyPriceCents = Math.round(totalPriceCents / durationDaysValue);
      const formattedDailyPrice = numberToEuro(dailyPriceCents).replace('€', ' €');
      dailyPriceContainer.textContent = `${formattedDailyPrice}/jour`;
    } else {
      dailyPriceContainer.textContent = '';
    }
  }

  const discountPriceContainer = targetElement.querySelector('.price-discount');
  if (discountPriceContainer) {
    if (!Number.isNaN(compareAtPriceCents) && !Number.isNaN(totalPriceCents) && compareAtPriceCents > totalPriceCents) {
      const discountPrice = Math.round(((compareAtPriceCents - totalPriceCents) / compareAtPriceCents) * 100) || 0;
      discountPriceContainer.textContent = `Économisez ${discountPrice}%`;
    } else {
      discountPriceContainer.textContent = '';
    }
  }
}

function getBundlerRoot() {
  const selectors = [
    '.product .kaching-bundles',
    '.product .kaching-subscriptions',
    '.product .bndlr-product',
    '.product [id^="_bndl_key_"]'
  ];

  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element) {
      return element;
    }
  }

  return null;
}

function findDatabaseInputFromElement(element, databaseItems) {
  if (!element || !databaseItems) {
    return null;
  }

  const dataset = element.dataset || {};
  const variantIdCandidates = [
    dataset.variantId,
    dataset.variantid,
    dataset.variant,
    dataset.bundleVariantId,
    dataset.bundlevariantid,
    dataset.bndlrVariantId,
    dataset.productVariantId,
    element.value && element.tagName === 'INPUT' ? element.value : null
  ].filter(Boolean);

  for (const candidate of variantIdCandidates) {
    const candidateString = candidate.toString();
    const match = Array.from(databaseItems).find((input) => {
      return (
        input.value === candidateString ||
        input.dataset.id === candidateString ||
        input.dataset.variantId === candidateString
      );
    });

    if (match) {
      return match;
    }
  }

  const titleCandidates = [
    dataset.variantTitle,
    dataset.varianttitle,
    dataset.bndlrVariantTitle,
    dataset.bundleVariantTitle,
    dataset.title,
    dataset.optionValue,
    element.getAttribute('data-title')
  ].filter(Boolean);

  for (const title of titleCandidates) {
    const values = title
      .split('/')
      .map((value) => value.trim())
      .filter(Boolean);

    const match = findDatabaseInputByOptionValues(values, databaseItems);

    if (match) {
      return match;
    }
  }

  return null;
}

function collectBundleOptionEntries(bundlerRoot) {
  if (!bundlerRoot) {
    return [];
  }

  const candidateElements = Array.from(
    bundlerRoot.querySelectorAll(
      '[data-variant-id], [data-variant-title], [data-bundle-variant-id], [data-bundle-variant-title], [data-option-value], input[type="radio"], input[type="checkbox"], option'
    )
  );

  const containerSelectors = [
    'label',
    '[data-bundle-option]',
    '.bndlr-option',
    '.bndlr-product__option',
    '.bndlr-product__selection',
    '.bundle-option',
    '.product-form__input',
    '.kaching-bundles__bar',
    '.kaching-subscriptions__card-wrapper'
  ];

  const entriesMap = new Map();

  candidateElements.forEach((element) => {
    const container = containerSelectors
      .map((selector) => element.closest(selector))
      .find((match) => match) || element.closest('.option') || element.closest('.bundle-item') || element;

    if (!entriesMap.has(container)) {
      entriesMap.set(container, {
        container,
        sources: new Set(),
        input: null
      });
    }

    const entry = entriesMap.get(container);
    entry.sources.add(element);

    if (!entry.input && element.tagName === 'INPUT') {
      entry.input = element;
    }
  });

  entriesMap.forEach((entry) => {
    if (!entry.input) {
      const htmlFor = entry.container.getAttribute && entry.container.getAttribute('for');
      if (htmlFor) {
        entry.input = bundlerRoot.querySelector(`#${escapeSelectorValue(htmlFor)}`);
      }
    }

    if (!entry.input) {
      entry.input = entry.container.querySelector('input[type="radio"], input[type="checkbox"]');
    }
  });

  return Array.from(entriesMap.values());
}

function isBundleEntrySelected(entry) {
  if (!entry) {
    return false;
  }

  if (entry.input) {
    return Boolean(entry.input.checked || entry.input.dataset.checked === 'true');
  }

  return entry.container.classList.contains('is-selected') || entry.container.classList.contains('selected') || entry.container.getAttribute('aria-pressed') === 'true' || entry.container.getAttribute('aria-checked') === 'true';
}

function applyVariantToBundleEntries(entries, databaseItems) {
  entries.forEach((entry) => {
    const searchElements = [entry.input, ...entry.sources, entry.container].filter(Boolean);
    let matchedInput = null;

    for (const element of searchElements) {
      matchedInput = findDatabaseInputFromElement(element, databaseItems);
      if (matchedInput) {
        break;
      }
    }

    const additionalInputs = Array.from(entry.sources)
      .filter((source) => source && source.tagName === 'INPUT');
    const targetsForDataset = Array.from(
      new Set([entry.input, entry.container, ...additionalInputs].filter(Boolean))
    );

    if (matchedInput) {
      syncOptionDataset(targetsForDataset, matchedInput);
    }

    applyVariantPricing(entry.container, matchedInput);
  });
}

function setupBundlerListeners() {
  const bundlerRoot = getBundlerRoot();

  if (!bundlerRoot || bundlerRoot.dataset.bundleVariantsListenerAttached === 'true') {
    return;
  }

  const handler = () => {
    window.requestAnimationFrame(() => {
      updateSelectedVariants();
    });
  };

  ['change', 'input', 'click'].forEach((eventName) => {
    bundlerRoot.addEventListener(eventName, handler, true);
  });

  bundlerRoot.dataset.bundleVariantsListenerAttached = 'true';
}

function updateSelectedVariants() {
  if (!productVariantsDatabase) {
    return;
  }

  const productsVariantsContainer = document.querySelector('.product variant-radios');
  const bundlerRoot = getBundlerRoot();

  if (!productsVariantsContainer && !bundlerRoot) {
    return;
  }

  const productVariantsDatabaseItems = productVariantsDatabase.querySelectorAll('input');

  if (productsVariantsContainer) {
    const productVariantsOptions = productsVariantsContainer.querySelectorAll('.product-form__input');
    const productVariantsOptionsInput = productsVariantsContainer.querySelectorAll('input');

    if(productVariantsOptions.length == 1) {

      const productFirstOption = productVariantsOptions[0];
      const productFirstOptionValues = productFirstOption.querySelectorAll('label');

      // GET SELECTED VARIANTS

      let selectedVariants = [];

      productVariantsOptionsInput.forEach(input => {
        if(input.checked == true) {
          selectedVariants.push(input.value);
        }
      })

      productFirstOptionValues.forEach(label => {

        let values = [label.dataset.optionValue]

        let databaseInput = findDatabaseInputByOptionValues(values, productVariantsDatabaseItems);
        const relatedInput = findInputForLabel(label);

        if (databaseInput) {
          syncOptionDataset([label, relatedInput].filter(Boolean), databaseInput);
        }

        applyVariantPricing(label, databaseInput);

      })

    }else if(productVariantsOptions.length == 2) {

      const productFirstOption = productVariantsOptions[0];
      const productFirstOptionValues = productFirstOption.querySelectorAll('input');
      let productFirstOptionSelectedValue;

      productFirstOptionValues.forEach(input => {
        if(input.checked == true){
          productFirstOptionSelectedValue = input;
        }
      })

      const productSecondOption = productVariantsOptions[1];
      const productSecondOptionValues = productSecondOption.querySelectorAll('label');

      // UPDATE SECOND OPTION VALUES

      productSecondOptionValues.forEach(label => {

        let values = [productFirstOptionSelectedValue && productFirstOptionSelectedValue.value, label.dataset.optionValue]

        let databaseInput = findDatabaseInputByOptionValues(values, productVariantsDatabaseItems);
        const relatedInput = findInputForLabel(label);

        if (databaseInput) {
          syncOptionDataset([label, relatedInput].filter(Boolean), databaseInput);
        }

        applyVariantPricing(label, databaseInput);

      })

    }else {
      console.log("ERROR");
    }
  } else if (bundlerRoot) {
    setupBundlerListeners();

    const bundleEntries = collectBundleOptionEntries(bundlerRoot);

    if (!bundleEntries.length) {
      return;
    }

    const selectedEntries = bundleEntries.filter((entry) => isBundleEntrySelected(entry));
    const entriesToProcess = selectedEntries.length ? selectedEntries : bundleEntries;

    applyVariantToBundleEntries(entriesToProcess, productVariantsDatabaseItems);
  }
}
updateSelectedVariants();

document.addEventListener('bundler:bundle_widget_created', () => {
  setupBundlerListeners();
  updateSelectedVariants();
});

document.addEventListener('bundler:bundle_selection_changed', () => {
  updateSelectedVariants();
});

document.addEventListener('bundler:bundle_updated', () => {
  updateSelectedVariants();
});

/* UPDATE MAIN BUTTON PRICE */

const bundlerWidgetRootSelectors = [
  '.bundler-widget',
  '.bundler__widget',
  '.bundler-app',
  '.bundler',
  '.bundle-widget',
  '.bundleapp',
  '.bundle-app',
  '.bundleapp__widget',
  '.bundle_builder',
  '.kaching-bundles',
  '.kaching-subscriptions',
  '[data-bundle-widget]',
  '[data-bundler-widget]',
  '[data-kaching]',
  '[data-kaching-widget]',
  '[data-kaching-bundles]',
  '[data-kaching-subscriptions]',
  '[data-kaching-subscription]',
  '[data-widget="bundler"]',
  '[data-app="bundler"]',
  '[data-app="kaching"]'
];

function updateMainButtonPrice(selectedLabel) {

  debugLog('🔄 updateMainButtonPrice appelée, tentative:', priceUpdateAttempts + 1);

  function updatePrice(newPrice) {

    debugLog('💰 Mise à jour du prix du bouton avec:', newPrice);

    const productMainButton = document.querySelector('.product .product-form__submit');

      if (productMainButton) {

          const priceContainers = productMainButton.querySelectorAll('.final-price');
          priceContainers.forEach((container, index) => {
            if (index > 0 && container.parentElement === productMainButton) {
              container.remove();
            }
          });

          let priceContainer = priceContainers[0];

          if (priceContainer) {
              priceContainer.textContent = `${newPrice}`;
          } else {
              priceContainer = document.createElement("span");
              priceContainer.classList.add('final-price');
              priceContainer.textContent = `${newPrice}`;
              productMainButton.appendChild(priceContainer);
          }
      }

  }

  function getTextContent(el) {
    if (!el) {
      return '';
    }

    if (el.dataset && el.dataset.bundlePriceFormatted) {
      return el.dataset.bundlePriceFormatted.trim();
    }

    if (el.dataset && el.dataset.priceFormatted) {
      return el.dataset.priceFormatted.trim();
    }

    if (el.dataset && el.dataset.bundlePrice) {
      return el.dataset.bundlePrice.trim();
    }

    if (el.dataset && el.dataset.price) {
      return el.dataset.price.trim();
    }

    return el.textContent ? el.textContent.trim() : '';
  }

  function getActiveBundlerPrice() {
    const productContainer = document.querySelector('.product');
    if (!productContainer) {
      debugLog('❌ Pas de conteneur .product trouvé');
      return '';
    }

    let bundlerRoot = null;
    for (const selector of bundlerWidgetRootSelectors) {
      bundlerRoot = productContainer.querySelector(selector);
      if (bundlerRoot) {
        debugLog('✅ Bundle widget trouvé avec sélecteur:', selector);
        break;
      }
    }

    if (!bundlerRoot) {
      debugLog('❌ Aucun bundle widget trouvé');
      return '';
    }

    const activePriceSelectors = [
      '.sls-one-time-price.sls-active .money',
      '.sls-one-time-price[aria-pressed="true"] .money',
      '.sls-one-time-price[aria-selected="true"] .money',
      '.sls-one-time-price[aria-checked="true"] .money',
      '.sls-one-time-price.active .money',
      '.sls-one-time-price.is-active .money',
      '.sls-one-time-price.selected .money',
      '.sls-one-time-price .money.sls-active',
      '.sls-one-time-price .money.active',
      '.sls-one-time-price .money.is-active',
      '.sls-one-time-price .money.selected',
      '.sls-one-time-price .money[data-selected="true"]',
      '.sls-selling-plan-group-price.sls-active .money',
      '.sls-selling-plan-group-price[aria-pressed="true"] .money',
      '.sls-selling-plan-group-price[aria-selected="true"] .money',
      '.sls-selling-plan-group-price[aria-checked="true"] .money',
      '.sls-selling-plan-group-price.active .money',
      '.sls-selling-plan-group-price.is-active .money',
      '.sls-selling-plan-group-price.selected .money',
      '.sls-selling-plan-group-price .money.sls-active',
      '.sls-selling-plan-group-price .money.active',
      '.sls-selling-plan-group-price .money.is-active',
      '.sls-selling-plan-group-price .money.selected',
      '.sls-selling-plan-group-price .money[data-selected="true"]',
      '.bundle-price.is-active .money',
      '.bundle-price.active .money',
      '.bundle-price.selected .money',
      '.kaching-bundles__bar--selected .kaching-bundles__bar-price',
      '.kaching-bundles__bar--selected [data-price]',
      '.kaching-subscriptions__card-wrapper input[type="radio"]:checked ~ .kaching-subscriptions__pricing .kaching-subscriptions__pricing-price',
      '.kaching-subscriptions__card-wrapper input[type="radio"]:checked ~ .kaching-subscriptions__price'
    ];

    function resolvePriceFromElement(element) {
      if (!element) {
        return '';
      }

      const elementMatches = (el, selector) => Boolean(el && typeof el.matches === 'function' && el.matches(selector));

      if (elementMatches(element, 'input[type="radio"]')) {
        const wrapper = element.closest('.kaching-subscriptions__card-wrapper');
        if (wrapper) {
          const textFromWrapper = resolvePriceFromElement(wrapper);
          if (textFromWrapper) {
            return textFromWrapper;
          }
        }
      }

      if (elementMatches(element, '.kaching-subscriptions__card-wrapper')) {
        const checkedInput = element.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          const priceEl = element.querySelector('.kaching-subscriptions__pricing-price') ||
            element.querySelector('.kaching-subscriptions__price') ||
            element.querySelector('[data-price]');
          const text = getTextContent(priceEl);
          if (text) {
            return text;
          }
        }
      }

      if (elementMatches(element, '.kaching-bundles__bar--selected')) {
        const priceEl = element.querySelector('.kaching-bundles__bar-price') ||
          element.querySelector('[data-price]');
        const text = getTextContent(priceEl);
        if (text) {
          return text;
        }
      }

      return getTextContent(element);
    }

    for (const selector of activePriceSelectors) {
      const el = bundlerRoot.querySelector(selector);
      if (el) {
        debugLog('🔍 Élément trouvé avec sélecteur:', selector);
      }
      const text = resolvePriceFromElement(el);
      if (text) {
        debugLog('✅ Prix trouvé:', text, 'via sélecteur:', selector);
        return text;
      }
    }

    const activeContainerSelectors = [
      '.sls-one-time-price.sls-active',
      '.sls-one-time-price[aria-pressed="true"]',
      '.sls-one-time-price[aria-selected="true"]',
      '.sls-one-time-price[aria-checked="true"]',
      '.sls-one-time-price.active',
      '.sls-one-time-price.is-active',
      '.sls-one-time-price.selected',
      '.sls-selling-plan-group-price.sls-active',
      '.sls-selling-plan-group-price[aria-pressed="true"]',
      '.sls-selling-plan-group-price[aria-selected="true"]',
      '.sls-selling-plan-group-price[aria-checked="true"]',
      '.sls-selling-plan-group-price.active',
      '.sls-selling-plan-group-price.is-active',
      '.sls-selling-plan-group-price.selected',
      '.kaching-bundles__bar--selected',
      '.kaching-subscriptions__card-wrapper input[type="radio"]:checked',
      '.kaching-subscriptions__card-wrapper.is-active',
      '.kaching-subscriptions__card-wrapper.selected'
    ];

    for (const selector of activeContainerSelectors) {
      const el = bundlerRoot.querySelector(selector);
      if (el) {
        debugLog('🔍 Conteneur actif trouvé avec sélecteur:', selector);
      }
      const text = resolvePriceFromElement(el);
      if (text) {
        debugLog('✅ Prix trouvé depuis conteneur actif:', text, 'via sélecteur:', selector);
        return text;
      }
    }

    const fallbackSelectors = [
      '.sls-active .money',
      '.sls-active',
      '.bundle-price .money',
      '.bundle-price',
      '.bundler__price .money',
      '.bundler__price',
      '.bundler-price .money',
      '.bundler-price',
      '.bundler-total-price .money',
      '.bundler-total-price',
      '.bundle-total-price .money',
      '.bundle-total-price',
      '.kaching-bundles__bar--selected .kaching-bundles__bar-price',
      '.kaching-bundles__bar-price',
      '[data-bundle-price-formatted]',
      '[data-bundle-price]',
      '[data-price-formatted]',
      '[data-price]'
    ];

    debugLog('⚠️ Tentative avec sélecteurs de fallback...');
    for (const selector of fallbackSelectors) {
      const el = bundlerRoot.querySelector(selector);
      if (el) {
        debugLog('🔍 Fallback trouvé avec sélecteur:', selector);
      }
      const text = resolvePriceFromElement(el);
      if (text) {
        debugLog('✅ Prix trouvé via fallback:', text, 'via sélecteur:', selector);
        return text;
      }
    }

    debugLog('❌ Aucun prix trouvé dans le bundle widget');
    return '';
  }

  const bundlerPrice = getActiveBundlerPrice();
  if (bundlerPrice) {
    updatePrice(bundlerPrice);
    return;
  }

  const slsPurchaseOptionsContainer = document.querySelector('.product .sls-purchase-options-container');

  if (slsPurchaseOptionsContainer != null) {
    const selectedSubscriptionOptionPrice = slsPurchaseOptionsContainer.querySelector('.sls-active .money');
    const slsPrice = getTextContent(selectedSubscriptionOptionPrice);
    if (slsPrice) {
      updatePrice(slsPrice);
      return;
    }
  }

  const checkedInputs = document.querySelectorAll(
    '.product .product-form__input input:checked'
  );

  for (const input of checkedInputs) {
    const totalPriceData = input.dataset.optionPrice;
    const priceCents = totalPriceData ? parseInt(totalPriceData, 10) : NaN;

    if (!Number.isNaN(priceCents)) {
      updatePrice(numberToEuro(priceCents));
      break;
    }

    const inputLabel = document.querySelector(`label[for="${input.id}"]`);
    const priceEl = inputLabel && inputLabel.querySelector('.option-price .regular-price');
    if (priceEl && priceEl.textContent.trim()) {
      updatePrice(priceEl.textContent.trim());
      break;
    }
  }

}

/* ===============================================
   FONCTION AVEC RETRY INTELLIGENT
   =============================================== */

function updateMainButtonPriceWithRetry() {
  debugLog('🚀 Début updateMainButtonPriceWithRetry, tentative:', priceUpdateAttempts + 1);
  
  // Appeler la fonction principale
  updateMainButtonPrice();
  
  // Vérifier si on a réussi à trouver un prix
  const productMainButton = document.querySelector('.product .product-form__submit');
  const priceContainer = productMainButton && productMainButton.querySelector('.final-price');
  const currentPrice = priceContainer ? priceContainer.textContent.trim() : '';
  
  // Si on a un prix valide (contient € et n'est pas vide), success!
  if (currentPrice && currentPrice.includes('€')) {
    debugLog('✅ Prix trouvé avec succès:', currentPrice);
    priceUpdateAttempts = 0; // Reset le compteur
    return;
  }
  
  // Si on n'a pas de prix et qu'il reste des tentatives
  if (priceUpdateAttempts < MAX_RETRY_ATTEMPTS) {
    const nextDelay = RETRY_DELAYS[priceUpdateAttempts];
    debugLog(`⏳ Aucun prix trouvé, nouvelle tentative dans ${nextDelay}ms (tentative ${priceUpdateAttempts + 1}/${MAX_RETRY_ATTEMPTS})`);
    
    priceUpdateAttempts++;
    
    setTimeout(() => {
      updateMainButtonPriceWithRetry();
    }, nextDelay);
  } else {
    debugLog('❌ Nombre maximum de tentatives atteint (' + MAX_RETRY_ATTEMPTS + '), abandon');
    priceUpdateAttempts = 0; // Reset le compteur
  }
}

let bundlerSyncTimeoutId = null;

function resolveBundlerWidgetElement(candidate) {
  if (!candidate) {
    return null;
  }

  if (Array.isArray(candidate)) {
    for (const item of candidate) {
      const resolvedFromArray = resolveBundlerWidgetElement(item);
      if (resolvedFromArray) {
        return resolvedFromArray;
      }
    }
    return null;
  }

  if (typeof Element !== 'undefined' && candidate instanceof Element) {
    return candidate;
  }

  if (candidate.nodeType === 1) {
    return candidate;
  }

  if (candidate.jquery && candidate.length) {
    return resolveBundlerWidgetElement(candidate[0]);
  }

  if (typeof candidate === 'object') {
    const possibleKeys = ['element', 'el', '$el', 'target', 'currentTarget', 'container', 'widget', 'bundle_widget', 'root', 'node'];
    for (const key of possibleKeys) {
      if (candidate[key] && candidate[key] !== candidate) {
        const resolved = resolveBundlerWidgetElement(candidate[key]);
        if (resolved) {
          return resolved;
        }
      }
    }
  }

  return null;
}

function findBundlerWidgets() {
  const productContainer = document.querySelector('.product');
  if (!productContainer) {
    return [];
  }

  const widgets = new Set();
  for (const selector of bundlerWidgetRootSelectors) {
    productContainer.querySelectorAll(selector).forEach((widget) => {
      widgets.add(widget);
    });
  }

  return Array.from(widgets);
}

function scheduleBundlerSync() {
  if (bundlerSyncTimeoutId) {
    clearTimeout(bundlerSyncTimeoutId);
  }

  bundlerSyncTimeoutId = setTimeout(() => {
    bundlerSyncTimeoutId = null;
    updateSelectedVariants();
    priceUpdateAttempts = 0; // Reset pour une nouvelle synchro
    updateMainButtonPriceWithRetry();
  }, 120);
}

function bindBundlerWidget(widgetRoot) {
  if (!widgetRoot) {
    return;
  }

  const isElementNode = typeof Element === 'undefined' ? widgetRoot.nodeType === 1 : widgetRoot instanceof Element;
  if (!isElementNode) {
    return;
  }

  if (bundlerWidgetsWithListeners.has(widgetRoot)) {
    return;
  }

  bundlerWidgetsWithListeners.add(widgetRoot);

  const interactionSelectors = [
    '.sls-one-time-price',
    '.sls-selling-plan-group-price',
    '[data-bundler-option]',
    '[data-bundle-option]',
    '.bundler-option',
    '.bundle-option',
    '.sls-option-container',
    'input',
    'select',
    'button',
    'label'
  ].join(', ');

  const handleInteraction = (event) => {
    if (!event || !event.target) {
      return;
    }

    if (event.target.closest(interactionSelectors)) {
      scheduleBundlerSync();
    }
  };

  widgetRoot.addEventListener('click', handleInteraction, true);
  widgetRoot.addEventListener('change', handleInteraction, true);

  if (typeof MutationObserver !== 'undefined') {
    const observedMutations = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' || mutation.type === 'childList') {
          scheduleBundlerSync();
          break;
        }
      }
    });

    try {
      observedMutations.observe(widgetRoot, {
        attributes: true,
        childList: true,
        subtree: true
      });
    } catch (error) {
      console.warn('Bundler observer error', error);
    }
  }

  const bundlerSpecificEvents = [
    'bundler:bundle_updated',
    'bundler:bundle_price_changed',
    'bundler:selection_changed',
    'bundler:bundle_selection_changed',
    'bundler:options_changed'
  ];

  bundlerSpecificEvents.forEach((eventName) => {
    widgetRoot.addEventListener(eventName, scheduleBundlerSync);
  });

  scheduleBundlerSync();
}

function initializeBundlerWidgets() {
  const widgets = findBundlerWidgets();
  widgets.forEach((widget) => {
    bindBundlerWidget(widget);
  });
}

function handleBundlerLifecycleEvent(event) {
  const detailElement = resolveBundlerWidgetElement(event && event.detail);
  const targetElement = resolveBundlerWidgetElement(event && event.target);
  const widgetRoot = detailElement || targetElement;

  if (widgetRoot) {
    bindBundlerWidget(widgetRoot);
  } else {
    initializeBundlerWidgets();
  }

  scheduleBundlerSync();
}

const bundlerLifecycleEvents = [
  'bundler:bundle_widget_created',
  'bundler:loaded',
  'bundler:initialized'
];

if (typeof document !== 'undefined') {
  bundlerLifecycleEvents.forEach((eventName) => {
    document.addEventListener(eventName, handleBundlerLifecycleEvent);
  });
}

// Initialisation avec retry intelligent (pas de setTimeout nécessaire)
updateMainButtonPriceWithRetry();

setTimeout(() => {
  initializeBundlerWidgets();
}, 300);

/* PRODUCT VARIANS ADVANCED */

const productVariantAdvanced = document.querySelector('.product-variant-advanced');

function updateVariantDuration() {

  let customOptionQuantity = 1;

  if (productVariantAdvanced) {
    const customOptionSelected = productVariantAdvanced.querySelector('.option__item.selected');
    const parsedQuantity = customOptionSelected
      ? parseFloat(customOptionSelected.dataset.quantity)
      : NaN;

    if (Number.isFinite(parsedQuantity) && parsedQuantity > 0) {
      customOptionQuantity = parsedQuantity;
    }
  }

  const quantityOption = document.querySelector('.product .product-form__input[data-option="Quantité"]');

  if (!quantityOption) {
    return;
  }

  const quantityOptionInput = quantityOption.querySelectorAll('input');

  // UPDATE QUANTITY ALL OPTIONS
  
  let dailyCostStatus = true;

  let newDurationDays;
  let newDurationMonths;
  let weight;
  let finalDailyCost;
  let measureUnit;
  
  quantityOptionInput.forEach(option => {

    // SET INFORMATIONS
    
    if(option.checked == true) {

      if(option.dataset.optionMeasureUnit != ""){
          measureUnit = option.dataset.optionMeasureUnit;
      }

      if(option.dataset.optionDurationDays != ""){
          newDurationDays = option.dataset.optionDurationDays/customOptionQuantity;
      }

      if(option.dataset.optionWeight != ""){
          weight = option.dataset.optionWeight;
      }

      if(option.dataset.optionPrice != ""){
          finalDailyCost = option.dataset.optionPrice/newDurationDays;
      }
      
    }

    // CHECK META
    
    if(option.dataset.optionMeasureUnit == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionDurationDays == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionWeight == ""){
        dailyCostStatus = false;
    }

    if(option.dataset.optionPrice == ""){
        dailyCostStatus = false;
    }
    
    // SET PRODUCTS DURATION
    
    const inputLabel = quantityOption.querySelector(`label[for="${option.id}"]`);
    const durationContainer = inputLabel && inputLabel.querySelector('.option-name .option-duration');
    const dailyPriceContainer = inputLabel && inputLabel.querySelector('.option-price .daily-price');
    const optionWeight = option.dataset.optionWeight;
    const optionMeasureUnit = option.dataset.optionMeasureUnit;
    const optionDurationMonth = option.dataset.optionDurationMonth;
    const optionDurationDays = option.dataset.optionDurationDays;
    const optionPriceCents = option.dataset.optionPrice;

    if (durationContainer) {
      const durationContent = [];

      if (optionWeight) {
        let measureUnitSuffix = '';

        if (optionMeasureUnit) {
          measureUnitSuffix = optionMeasureUnit.startsWith(' ')
            ? optionMeasureUnit
            : ` ${optionMeasureUnit}`;
        }

        durationContent.push(`<span class="weight">${optionWeight}${measureUnitSuffix}</span>`);
      }

      if (optionDurationMonth) {
        const parsedDurationMonth = parseFloat(optionDurationMonth);

        if (!Number.isNaN(parsedDurationMonth)) {
          newDurationMonths = Math.round(parsedDurationMonth / customOptionQuantity * 100) / 100;
          const formattedDuration = formatDurationMonths(newDurationMonths);

          if (formattedDuration) {
            if (durationContent.length) {
              durationContent.push(`(${formattedDuration})`);
            } else {
              durationContent.push(formattedDuration);
            }
          }
        }
      }

      durationContainer.innerHTML = durationContent.join(' ');
    }

    if (dailyPriceContainer) {
      const durationDaysValue = optionDurationDays ? parseFloat(optionDurationDays) : NaN;
      const priceCentsValue = optionPriceCents ? parseInt(optionPriceCents, 10) : NaN;
      let effectiveDurationDays = durationDaysValue;

      if (Number.isFinite(durationDaysValue) && customOptionQuantity > 0) {
        effectiveDurationDays = durationDaysValue / customOptionQuantity;
      }

      if (
        Number.isFinite(priceCentsValue) &&
        Number.isFinite(effectiveDurationDays) &&
        effectiveDurationDays > 0
      ) {
        const dailyPriceCents = Math.round(priceCentsValue / effectiveDurationDays);
        const formattedDailyPrice = numberToEuro(dailyPriceCents).replace('€', ' €');
        dailyPriceContainer.textContent = `${formattedDailyPrice}/jour`;
      } else {
        dailyPriceContainer.textContent = '';
      }

    }

  })
  
  const dailyCost = document.querySelector('.product .daily-cost');

  if (!dailyCost) {
    return;
  }

  if(dailyCostStatus == true){
    dailyCost.classList.add('active')
  }else if(dailyCostStatus == false){
    dailyCost.classList.remove('active');
  }

  // UPDATE DAILY COST

  const dailyCostDaysContainer = dailyCost.querySelector('.days');
  const dailyCostWeightContainer = dailyCost.querySelector('.weight');
  const dailyCostPriceContainer = dailyCost.querySelector('.price');

  if (dailyCostDaysContainer) {
    dailyCostDaysContainer.innerHTML = `${newDurationDays}`;
  }

  if (dailyCostWeightContainer) {
    dailyCostWeightContainer.innerHTML = `${weight}${measureUnit}`;
  }

  if (dailyCostPriceContainer) {
    dailyCostPriceContainer.innerHTML = `${numberToEuro(finalDailyCost)}`;
  }

}
updateVariantDuration();

function updateVariantSelectionSummary(variantElement, selectedOption) {

  if (!variantElement) {
    return;
  }

  const selectionContainer = variantElement.querySelector('[data-variant-selection]');
  const selectionValue = variantElement.querySelector('[data-variant-selection-value]');

  if (!selectionContainer || !selectionValue) {
    return;
  }

  selectionValue.innerHTML = '';

  if (!selectedOption) {
    selectionContainer.classList.add('is-hidden');
    return;
  }

  const optionName = selectedOption.querySelector('.item__name');

  if (optionName) {
    selectionValue.appendChild(optionName.cloneNode(true));
    selectionContainer.classList.remove('is-hidden');
  } else {
    selectionContainer.classList.add('is-hidden');
  }
}

function updateOptionsTags(option) {

  const recommendedDuration = option.dataset.quantity*2;
  const optimumDuration = option.dataset.quantity*4;

  const productOptionQuantityLabel = document.querySelectorAll('.product-form__input[data-option="Quantité"] label');

  productOptionQuantityLabel.forEach(label => {

    const tagContainer = label.querySelector('.tag');
    
    if(label.dataset.durationMonth == recommendedDuration){
      tagContainer.innerHTML = `Recommandé`;
      label.classList.add('with-tag');
    }else if(label.dataset.durationMonth == optimumDuration){
      tagContainer.innerHTML = `Cure optimale`;
      label.classList.add('with-tag');
    }else {
      tagContainer.innerHTML = ``;
      label.classList.remove('with-tag');
    }
    
  })
  
}
if(productVariantAdvanced){ 
  const productVariantAdvancedVariants = productVariantAdvanced.querySelectorAll('.variant__item');
  productVariantAdvancedVariants.forEach(variant => {
    const variantOptions = variant.querySelectorAll('.option__item');
    const defaultSelectedOption = variant.querySelector('.option__item.selected') || variantOptions[0];

    if (defaultSelectedOption) {
      updateOptionsTags(defaultSelectedOption);
      updateVariantSelectionSummary(variant, defaultSelectedOption);
    }

    variantOptions.forEach(option => {

      option.addEventListener('click', () => {

        // SET DESIGN

        for(let i=0;i<variantOptions.length;i++){
            variantOptions[i].classList.remove('selected');
        }
        option.classList.add('selected');

        // ACTIONS

        updateVariantDuration();

        // UPDATE OPTIONS TAGS

        updateOptionsTags(option);

        // UPDATE ADVANCED VARIANT SELECTION LABEL

        updateVariantSelectionSummary(variant, option);

      })
    })

  })

}

// VARIANTS OPTIONS ACTIONS

const productOptionsLabel = document.querySelectorAll('.product .product-form__input label');

productOptionsLabel.forEach(label => {
  
  label.addEventListener('click', () => {
    
    setTimeout(() => {
      updateSelectedVariants();
      updateVariantDuration();
    }, 100);
    
    // Reset le compteur de tentatives pour un nouveau click
    priceUpdateAttempts = 0;
    setTimeout(() => {
      updateMainButtonPriceWithRetry();
    }, 100);
    
  })
})

// SUBSCRIPTION OPTIONS ACTIONS

setTimeout(() => {
  
  const slsPurchaseContainer = document.querySelector('.product .sls-purchase-options-container');
  
  if(slsPurchaseContainer != null) {
    
    const slsOptions = slsPurchaseContainer.querySelectorAll('.sls-option-container');
  
    slsOptions.forEach(option => {
      option.addEventListener('click', () => {
        // Reset le compteur de tentatives pour un nouveau click
        priceUpdateAttempts = 0;
        setTimeout(() => {
          updateMainButtonPriceWithRetry();
        }, 100);
      })
    })

  }
  
}, 300);

// STICKY ATC - SCROLL APPARITION

const mainProductButtonAtc = document.querySelector('.product');
const productStickyAtc = document.querySelector('.product-sticky-atc');

const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            productStickyAtc.removeAttribute('open');
        } else {
            productStickyAtc.setAttribute('open', '');
        }
    });
}, {
    threshold: 0
});

stickyObserver.observe(mainProductButtonAtc);